import { render } from "./mail.vue?vue&type=template&id=4482bee0&scoped=true"
import script from "./mail.vue?vue&type=script&lang=js"
export * from "./mail.vue?vue&type=script&lang=js"

import "./mail.vue?vue&type=style&index=0&id=4482bee0&lang=scss&scoped=true"
import "./mail.vue?vue&type=style&index=1&id=4482bee0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4482bee0"]])

export default __exports__